import React from "react";
import { IoMdMail } from "react-icons/io";
import { MdLocalPhone } from "react-icons/md";

export default function TextInput({
  label,
  placeholder,
  type,
  value,
  onChange,
  error,
}) {
  const borderColor = error ? "border-red-500" : "border-gray-300";
  const iconColor = error
    ? "text-red-500"
    : value
    ? "text-default"
    : "text-gray-300";
  const textColor = error ? "text-red-500" : "text-default";

  const placeholderColor = error
    ? "placeholder-red-600"
    : "placeholder-gray-400";

  return (
    <div className="flex flex-1 relative flex-col gap-1 w-full">
      {label && (
        <label className={`text-[15px] text-start text-default`}>{label}</label>
      )}

      <div
        className={`flex items-center gap-2 border ${borderColor} rounded-xl px-4 py-3 bg-white focus-within:border-gray-600 transition`}
      >
        {type === "email" && <IoMdMail className={iconColor} />}
        {type === "phone" && <MdLocalPhone className={iconColor} />}

        <input
          type="text"
          placeholder={placeholder}
          className={`w-full outline-none ${textColor} ${placeholderColor} text-[15px]`}
          value={value}
          onChange={onChange}
        />
      </div>

      {error && (
        <span className="text-red-600 absolute -bottom-6 left-0 text-[13px]">
          {error}
        </span>
      )}
    </div>
  );
}
